import { createRecordListLoader } from '@/store/utils/loader';

export default createRecordListLoader({
  namespaced: true,
  config: {
    url: (id) => `/projects/${id}/tags.json`,
    module: 'tag',
  },
});
